import React from "react";

const HeartbeatIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      data-slot="icon"
      {...props}
    >
      {/* Realistic ECG: flat - small dip - sharp spike up - sharp spike down - flat */}
      <path d="M1 10h4l1 2 2-9 2 14 2-9 1 2h6" />
    </svg>
  );
};

export default HeartbeatIcon;
